import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "sonner";
import { removeFromQueue } from "../../services/queue";
import { QueueEntryApi } from "../../services/queue/types";
import { patientDisplayName } from "../../services/queue/stats";
import ModalUI from "../legacy/Modal";
import { QueueModalActions } from "./QueueModalParts";

type RemoveQueueEntryModalProps = {
  entry: QueueEntryApi;
  onClose: () => void;
};

/** Confirmation avant de retirer un patient de la liste (départ, erreur d'ajout). */
const RemoveQueueEntryModal: React.FC<RemoveQueueEntryModalProps> = ({ entry, onClose }) => {
  const queryClient = useQueryClient();
  const { mutate: remove, isLoading } = useMutation(() => removeFromQueue(entry.id), {
    onSuccess: (result: any) => {
      if (!result?.ok) return;
      toast.success("Patient retiré de la liste");
      queryClient.invalidateQueries(["queue-today-list"]);
      onClose();
    },
  });

  return (
    <ModalUI
      isOpen
      onClose={() => {
        if (!isLoading) onClose();
      }}
      styles={{ width: "min(440px, 92vw)", padding: 0 }}
    >
      <div className="flex flex-col">
        <div className="flex items-start gap-4 px-6 pt-6">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-rose-50 text-rose-600 ring-1 ring-rose-100">
            <i className="bx bx-user-x text-2xl" aria-hidden />
          </div>
          <div className="space-y-1">
            <h2 className="text-lg font-semibold text-slate-900 leading-tight">Retirer de la liste ?</h2>
            <p className="text-sm text-slate-500">
              <span className="font-medium text-slate-800">{patientDisplayName(entry)}</span> ne sera plus
              dans la liste d'attente du jour. Son dossier n'est pas modifié.
            </p>
          </div>
        </div>
        <QueueModalActions
          onCancel={onClose}
          onConfirm={() => remove()}
          confirmLabel="Retirer"
          confirmIcon="bx-user-x"
          confirmDisabled={isLoading}
          isLoading={isLoading}
          variant="danger"
        />
      </div>
    </ModalUI>
  );
};

export default RemoveQueueEntryModal;
